<template>
  <vs-prompt
    title="Password Authentication"
    type="confirm"
    accept-text="OK"
    @cancel="cancelled"
    @accept="accepted"
    @close="cancelled"
    :active.sync="activeSync"
    :is-valid="password !== ''"
  >
    <div class="con-2fa-otp-prompt">
      <div>
        <vs-input label="Password" type="password" v-model="password" />
      </div>
    </div>
  </vs-prompt>
</template>
<script>
import { DASHBOARD_VERIFICATION_TYPE } from '../constants';

export default {
  props: {
    active: Boolean,
    login: String,
  },
  data() {
    return {
      password: '',
      activeSync: this.active,
      clientId: process.env.VUE_APP_CLIENT_ID,
    };
  },
  watch: {
    activeSync: function (val) {
      this.$emit('update:active', val);
    },
    active: function (val) {
      this.activeSync = val;
      if (val) {
        this.password = '';
      }
    },
  },
  mounted() {},
  methods: {
    async cancelled() {
      // this.activeSync = true
    },

    async accepted() {
      // this is to make sure the dialog doesn't disappear before verification happen.
      this.activeSync = true;
      const verificationPayload = {
          [`${DASHBOARD_VERIFICATION_TYPE.PASSWORD}`]: this.password
      };
      this.$emit('verify', verificationPayload);
      this.activeSync = false; 
      this.password = '';
      
      // await this.emailPasswordVerify(this.login, this.password).then((res) => {
      //   if (res.status === 200) {
      //     this.$emit('verify', true);
      //     this.activeSync = false;
      //     this.password = '';
      //   } else {
      //     console.log(`error`);
      //     this.$vs.notify({
      //       title: 'Error',
      //       text: 'Invalid login and password',
      //       color: 'danger',
      //     });
      //   }
      // });
    },
  },
};
</script>

<style lang="stylus">
.con-2fa-otp-prompt
  padding 10px;
  padding-top 0px;
.con-2fa-otp-prompt .vs-input
  width 100%
  margin-top 10px;
.con-text-noti p
  color: #ffffff;
.my-box
  border: 1px solid rgba(0, 0, 0, 0.2)
  border-radius: 5px
  padding: 0.5rem
  font-size: 1rem;
</style>
